module.exports = __webpack_public_path__ + "img/city6.4c074dfc.png";